export default "__VITE_PUBLIC_ASSET__08328d0b__"